<template>
  <div>

    <!-- Dropdown -->
    <label
      v-if="fieldsData.type === 'dropdown'"
      class="form__row"
    >
      <span class="form__row-label">{{fieldsData.label}} <span v-if="fieldsData.required">*</span></span>
      <div class="input-select">
        <select
          v-model="value"
          class="input"
          :disabled="isDisabledEditing"
          :class="{
                  'is-invalid': (fieldsData.required && error && (value == null || value.length == 0)) || (fieldsData.required && $v.value.$dirty && !$v.value.required),
                  'disabled': isDisabledEditing
                }"
          @blur="$v.value.$touch"
          :required="fieldsData.required"
          @change="emitChanges"
        >
          <option
            v-for="(option, index) in fieldsData.options"
            :key="index"
            :value="option.name"
          >{{option.name}}</option>
        </select>
      </div>
    </label>


    <!-- Multi Select -->
    <div
      v-if="fieldsData.type === 'multi_select'"
    >
      <span class="form__row-label">{{fieldsData.label}} <span v-if="fieldsData.required">*</span></span>
      <div>
        <v-select
          class="multiple-select"
          placeholder="Select"
          multiple
          :disabled="isDisabledEditing"
          v-model="value"
          :closeOnSelect="false"
          :options="fieldsData.options"
          label="name"
          :reduce="option => option.name"
          :deselectFromDropdown = "true"
          :class="{'is-invalid': (fieldsData.required && error && (value == null || value.length == 0)) || (fieldsData.required && $v.value.$dirty && !$v.value.required) }"
          @input="emitChanges"
        >
          <template
            #option="{ name }"
          >
            <span>{{name}}</span>
          </template>
        </v-select>
      </div>
    </div>


    <!-- Checkbox -->
    <div
      v-if="fieldsData.type === 'checkbox'"
      class="form__row"
    >
      <span class="form__row-label">{{fieldsData.label}} <span v-if="fieldsData.required">*</span></span>
      <label
        v-for="(option, index) in fieldsData.options"
        :key="index"
        class="nice-checkbox"
      >
        <input
          type="checkbox"
          v-model="value"
          :disabled="isDisabledEditing"
          :class="{
            'is-invalid': (fieldsData.required && error && !value) || (fieldsData.required && $v.value.$dirty && !$v.value.required),
            'disabled': isDisabledEditing
          }"
          :value="option"
          @change="emitChanges"
        />
        <span>{{option}}</span>
      </label>
    </div>

    <!-- Radio Button -->
    <div
      v-if="fieldsData.type === 'radio_button'"
      class="form__row"
    >
      <span
        class="form__row-label"
        :class="{
            'is-invalid': (fieldsData.required && error && !value) || (fieldsData.required && $v.value.$dirty && !$v.value.required),
          }"
      >{{fieldsData.label}} <span v-if="fieldsData.required">*</span></span>
      <label
        v-for="(option, index) in fieldsData.options"
        :key="index"
        class="nice-radio"
      >
        <input
          type="radio"
          v-model="value"
          :disabled="isDisabledEditing"
          :class="{
            'is-invalid': (fieldsData.required && error && !value) || (fieldsData.required && $v.value.$dirty && !$v.value.required),
            'disabled': isDisabledEditing
          }"
          :value="option.name"
          @change="emitChanges"
        />
        <span>{{option.name}}</span>
      </label>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'


export default {
  name: 'DynamicFieldRow',
  components: {
    vSelect,
  },
  props: {
    fieldsData: {
      type: Object,
      default: () => {},
    },
    isDisabledEditing: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      error: false,
      value: null,
    }
  },
  mounted() {
    this.setValue()
  },
  validations() {
    return {
      value: {
        required,
      }
    }
  },
  methods: {
    setValue() {
      this.value = this.fieldsData.value
    },
    emitChanges() {
      this.fieldsData.value = this.value
      this.$emit('updateValue', { id: this.fieldsData.id, value: this.value })
    },
  },
}
</script>

<style lang="scss">
@import 'src/assets/scss/colors/colors';

.mx-datepicker{
  &.is-invalid{
    .input-date {
      border: 1px solid var(--error) !important;
      &::placeholder {
        color: var(--error)
      }
    }
  }
  &.disabled{
    .input-date{
      cursor: not-allowed;
      background-color: #cccccc;
      opacity: 0.7;
    }
  }

}
.multiple-select{
  margin-bottom: 30px;
}
.plain-text{
  margin: 30px 0;
  word-break: break-word;
  h1, h2, h3, h4, h5, h6, p, em, img, strong, sub, sup, b, u, i, dl, dt, dd, ol, ul, li, fieldset, form, label, table, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, figcaption, figure, a, footer, header, hgroup, menu, nav, section, summary, time, mark, audio, video {
    margin: revert;
    padding: revert;
    font-size: revert;
    list-style: revert;
  }
  img, video {
    max-width: 100%;
  }
}
.files {
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
}
.file {
  padding: 10px;
  position: relative;
  width: 32%;
  word-break: break-all;
  a {
    color: $secondary;
  }
  svg {
    height: 20px;
  }
  svg path, svg rect {
    fill: $primary;
  }
  &_remove {
    position: absolute;
    display: flex;
    align-items: center;
    top: 0;
    right: 0;
    width: 15px;
    height: 15px;
    cursor: pointer;

    &::before,&::after {
      content: '';
      display: block;
      position: absolute;
      left: 6px;
      width: 1px;
      height: 15px;
      background: $secondary;
      transform: rotate(45deg);
    }
    &::after{
      transform: rotate(-45deg);
    }
  }

}
.phone__row{
  width: 100%;
  margin-bottom: 30px;
}
.phone-number {
  border-radius: 12px;
  .maz-input {
    height: 60px;
    background: #EDEDED;
    border: none !important;
    border-color: none !important;
  }
  .maz-input__toggle-btn {
    display: none;
  }
  &.is-invalid{
    border: 1px solid var(--error) !important;
    &::placeholder {
      color: var(--error)
    }
  }
}
</style>
<style scoped>
.error {
  position: absolute;
  color: red;
  font-size: 14px;
}
</style>
